import { HomeRouterLayout } from "@spa/app/layouts/HomeRouterLayout";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";

const TasksPage = withSuspense(
  () => import("@dust-tt/front/components/pages/tasks/TasksPage"),
  "TasksPage"
);

// My Tasks shares Home's providers: it is the full page behind Home's task
// widget, and opens the same `?panel=task:` detail sheet.
export const tasksRoutes: RouteObject[] = [
  {
    element: <HomeRouterLayout />,
    children: [{ path: "tasks", element: <TasksPage /> }],
  },
];
